import {FC, useEffect} from 'react'
import {useLang} from './Metronici18n'
import {IntlProvider} from 'react-intl'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/fa'

import enMessages from './messages/en.json'
import faMessages from './messages/fa.json'
import {WithChildren} from '../helpers'

const allMessages = {
  en: enMessages,
  fa: faMessages,
}
type lang = 'en'|'fa'
const I18nProvider: FC<WithChildren> = ({children}) => {
  const locale = useLang()?.lang.selectedLang || (window?.RUNTIME_CONFIG?.REACT_APP_DEFAULT_LANGUAGE || process.env.REACT_APP_DEFAULT_LANGUAGE) as lang
  const messages = allMessages[locale]

  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  )
}

export {I18nProvider}
